<mat-card style="height: 530px">
  <form #loginForm="ngForm">
    <mat-toolbar style="float:left;clear:both;width:100%;" color="secondary">
      <h3 style="padding-left:5px">{{editInvoiceData.clau}}. {{ 'invoiceEditDialog.titolEmesa' | translate }} {{editInvoiceData.numero_factura}}        
        <button mat-icon-button style="clear:none;margin-left:10px" color="primary"
            (click)="openCurrencyDialog()"
            matTooltip="{{ 'propostaMi.economia.canviMonedaToolTip' | translate }}"
            attr.aria-label="{{ 'propostaMi.economia.canviMonedaAriaLabel' | translate }}">
            <mat-icon style="font-size:16px !important">currency_exchange</mat-icon>
        </button></h3>
      <div style="width:100%;float:right">
        <button mat-icon-button style="float: right; margin-right:0" (click)="close()" matTooltip="{{ 'common.tancar' | translate }}" attr.aria-label="{{ 'common.tancar' | translate }}" matTooltipClass="tooltip-style" >
          <mat-icon color="primary" style="font-size:24px">close</mat-icon>
        </button>
        <button mat-icon-button style="float: right; margin-right:0" (click)="desar()" matTooltip="{{ 'common.desar' | translate }}" attr.aria-label="{{ 'common.desar' | translate }}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">save</mat-icon>
        </button>
      </div>  
    </mat-toolbar>
    <mat-card-content style="float:left;clear:both;padding: 24px 5px;">
      <div style="float:left;clear:left;width:100%"> 
      <mat-form-field style="width:130px">
       <input matInput style="width:130px"
        placeholder="{{ 'invoiceEditDialog.numero' | translate }}" name="numero" type="number" min="0" step="1" required
        [(ngModel)]="editInvoiceData.numero_factura" ngDefaultControl
       />
      </mat-form-field> 
      <mat-form-field style="width:130px">
       <input matInput style="width:130px"
        placeholder="{{ 'invoiceEditDialog.dataFacturacioPrevista' | translate }}" name="data_factura_prevista" (change)="avis_data_cobrament()" type="date"
        [(ngModel)]="editInvoiceData.data_factura_prevista" ngDefaultControl
       />
      </mat-form-field> 
      <mat-form-field style="width:130px">
       <input matInput style="width:130px"
        placeholder="{{ 'invoiceEditDialog.dataCobramentPrevista' | translate }}" name="data_cobrament_prevista" type="date"
        [(ngModel)]="editInvoiceData.data_cobrament_prevista" ngDefaultControl
       />
      </mat-form-field> 
      <mat-form-field style="width:130px">
       <input matInput style="width:130px"
        placeholder="{{ 'invoiceEditDialog.dataFacturacio' | translate }}" name="data_factura" type="date" (change)="avis_data_cobrament()" 
        [(ngModel)]="editInvoiceData.data_factura" ngDefaultControl
       />
      </mat-form-field> 
      <mat-form-field style="width:130px">
       <input matInput style="width:130px"
        placeholder="{{ 'invoiceEditDialog.dataCobrament' | translate }}" name="data_cobrament" type="date" (change)="tx_avis_data_cobrament = false;cobrament_modificat = true"
        [(ngModel)]="editInvoiceData.data_cobrament" ngDefaultControl
       />
      </mat-form-field>
      </div>
      <div style="float:left;clear:left;width:100%"> 
      <mat-form-field style="width:130px">
       <input matInput style="width:130px"
        placeholder="{{ 'invoiceEditDialog.importBase' | translate }}" name="facturacio_prevista_loc" type="number" step="0.01" (change)="chgImportFactura()" 
        [(ngModel)]="editInvoiceData.facturacio_prevista_loc" ngDefaultControl
       />
      </mat-form-field> 
      <mat-form-field style="width:130px"> 
        <mat-select style="width:130px" [(ngModel)]="editInvoiceData.moneda_previsio" placeholder="{{ 'propostaMi.economia.moneda' | translate }}" name="moneda_previsio">
          <mat-option *ngFor="let moneda of possibleMonedes" [value]="moneda.codi" [selected]="moneda.text === editInvoiceData.moneda_previsio">{{moneda.text}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="width:130px">  
        <input matInput type="number" step="0.01" style="width:130px"
          placeholder="{{ 'propostaMi.economia.canvi' | translate }}" name="canvi_moneda"
          [(ngModel)]="editInvoiceData.canvi_moneda" formatNumberPipe ngDefaultControl
        />
      </mat-form-field>
      <mat-form-field style="width:130px">
       <input matInput 
        placeholder="{{ 'invoiceEditDialog.facturacioEur' | translate }}" name="facturacio_prevista_eur" type="number" disabled style="width:130px;color:#777777" formatNumberPipe 
        value="{{editInvoiceData.facturacio_prevista_loc*editInvoiceData.canvi_moneda}}" ngDefaultControl
       />
      </mat-form-field>
      <mat-form-field style="width:130px">
       <input matInput style="width:130px;color:#777777"
        placeholder="{{ 'facturacio.taula.colPercentPressupost' | translate }}" name="facturacio_prevista_percent" type="number" disabled
        [(ngModel)]="editInvoiceData.facturacio_prevista_percent" ngDefaultControl
       />
      </mat-form-field>
      </div>
      <div style="float:left;clear:left;width:100%"> 
      <!-- <mat-form-field>
       <input matInput style="width:130px"
        placeholder="Previsió de cobrament EUR (€)" name="previsio_cobrament" type="number" step="0.01" required
        [(ngModel)]="editInvoiceData.previsio_cobrament" ngDefaultControl
       />
      </mat-form-field>-->
      <mat-form-field style="width:130px">
       <input matInput  style="width:130px"
        placeholder="{{ 'invoiceEditDialog.impostosIva' | translate }}" name="iva" type="number" step="0.01" required
        [(ngModel)]="editInvoiceData.iva" ngDefaultControl
       />
      </mat-form-field>
      </div>
      <mat-form-field style="float:left;clear:left;width: 135px">
       <input matInput style="width:135px"
        placeholder="{{ 'invoiceEditDialog.cobramentEur' | translate }}" name="facturacio_cobrament" type="number" step="0.01" 
        [(ngModel)]="editInvoiceData.facturacio_cobrament" ngDefaultControl
       />
      </mat-form-field>
      <mat-form-field style="width:135px">
       <input matInput  style="width:135px"
        placeholder="{{ 'invoiceEditDialog.impostosLocal' | translate }}" name="impostos" type="number" step="0.01" required
        [(ngModel)]="editInvoiceData.impostos" ngDefaultControl
       />
      </mat-form-field>
      <mat-checkbox style="margin-left: 1em;" name="activa"
        [(ngModel)]="editInvoiceData.activa">
        {{ 'facturacio.taula.colActiva' | translate }}
      </mat-checkbox>
      <mat-checkbox matTooltip="{{ 'invoiceEditDialog.facturarJaPotEmetreToolTip' | translate }}" style="margin-left: 1em;color: #3f51b5" name="facturar"
        [(ngModel)]="editInvoiceData.facturar">
        {{ 'invoicesSummary.colFacturar' | translate }}
      </mat-checkbox>
      <mat-form-field style="width:70%">
        <mat-select style="width:100%" [(ngModel)]="data.fita" placeholder="{{ 'invoiceEditDialog.fita' | translate }}" name="fita">
          <mat-option *ngFor="let cmpFita of possibleFites" [value]="cmpFita.value" [selected]="cmpFita.value === editInvoiceData.fita">{{cmpFita.text}}</mat-option>
        </mat-select>
      </mat-form-field>
      <div *ngIf="tx_avis_data_cobrament" style="float:left;clear:none;width:300px;color:red;font-weight:bold;font-size:0.9em;height:30px">{{ 'invoiceEditDialog.avisModificarDataCobrament' | translate }}
      </div>
      <mat-form-field style="width:100%">
       <input matInput 
        placeholder="{{ 'invoiceEditDialog.objecteLliurament' | translate }}" name="objecte_lliurament"
        [(ngModel)]="editInvoiceData.objecte_lliurament" ngDefaultControl
       />
      </mat-form-field> 
      <mat-form-field style="width:100%">
       <input matInput style="width:100%" 
        placeholder="{{ 'facturacio.taula.colObservacions' | translate }}" name="observacions"
        [(ngModel)]="editInvoiceData.observacions" ngDefaultControl
       />
      </mat-form-field> 
    </mat-card-content>
  </form>
</mat-card>
